import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ResponseData } from 'src/app/Model/Base/Response';
import { ContactTypeModel } from 'src/app/Model/ContactType.model';
import { ContactsModel } from 'src/app/Model/Contacts.model';
import { RequestModel } from 'src/app/Model/Request.model';
import { UpdateStatusProcessModel } from 'src/app/Model/UpdateStatusProcess.model';
import { VRequestStatusProcessModel } from 'src/app/Model/VRequestStatusProcess.Model';
import { SessionStorageService } from 'src/app/Services/sessionStorageService/session-storage.service';
import { RequestService } from 'src/app/Services/request/request.service';
import { CustomValidators } from 'src/app/Util/CustomValidators';
import Swal from 'sweetalert2';
import { Flows } from 'src/app/Model/Enums/Flow.enums';
import { CreatePortalAdminRequest } from 'src/app/Model/CreatePortalAdminRequest.model';
import { PiaFlowsValidationService } from 'src/app/Services/PiaFlowsValidation/pia-flows-validation.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'agency-portal-admin',
  templateUrl: './agency-portal-admin.component.html',
  styleUrls: ['./agency-portal-admin.component.css']
})
export class AgencyPortalAdminComponent implements OnChanges{

  public isMobile: boolean = false;
  public contact: ContactsModel
  hideSaveButton: boolean = false;
  @Input() request: RequestModel;
  @Input() lstContactTypes: ContactTypeModel[];
  @Output() newRequestEvent = new EventEmitter<number>();
  allowEdit:boolean;
  @Input() lstStatuses: VRequestStatusProcessModel[];
  @Output() nextEvent = new EventEmitter();
  @ViewChild('popUp',{static: false})
  popUp: ElementRef;
  form = new FormGroup({
    name: new FormControl('',
      [Validators.required,
      CustomValidators.emptyTextValidator(),
      CustomValidators.AmpersandValidator(),
      CustomValidators.NoDoubleSpaceAllowedValidator(),
      Validators.maxLength(100),]),
    
    lastname: new FormControl('',
      [Validators.required,
      CustomValidators.emptyTextValidator(),
      CustomValidators.AmpersandValidator(),
      CustomValidators.NoDoubleSpaceAllowedValidator(),
      Validators.maxLength(100),]),
    email: new FormControl('',
      [Validators.required,
      Validators.maxLength(500),
      CustomValidators.emailValidator()]),
  });
  get email() { return this.form.get('email'); }
  get name() { return this.form.get('name'); }
  get lastname() { return this.form.get('lastname'); }
  codeSaved: string;
  lang: string;
  constructor(
    private readonly requestService: RequestService,
    breakpointObserver: BreakpointObserver,
    private readonly translate: TranslateService,
    private readonly spinner: NgxSpinnerService,
    private readonly lsService : SessionStorageService,
    private readonly piaFlowsValidationService: PiaFlowsValidationService) {
    breakpointObserver.observe([
      Breakpoints.Handset
    ]).subscribe(result => {
      this.isMobile = result.matches;
    });
    this.request = Object.assign({}, this.request);
    this.contact = new ContactsModel();

    this.lang = this.lsService.getLSItem('language')
    
    if (this.lang == "en") {

      if(this.lstContactTypes != null)
      {
        this.lstContactTypes.forEach(element => {
          if (element.Description == "Comercial") {
            element.Description = "Commercial"
          }

          if (element.Description == "Financiero") {
            element.Description = "Financial"
          }
        });
      }
      

    }

    if (this.lang == "pt") {

      if(this.lstContactTypes != null)
      {
        this.lstContactTypes.forEach(element => {
          if (element.Description == "Comercial") {
            element.Description = "Commercial"
          }
  
          if (element.Description == "Financiero") {
            element.Description = "Financeiro"
          }
        });
      }
      
    }

  }
  async ngOnChanges() {
    this.email.enable();
    this.name.enable();
    this.lastname.enable();
    this.allowEdit= await this.lstStatuses.some(x=>x.IdComponent==6)
    let idrequest = this.lsService.getLSItem("IdRequest");
    let rq = await this.requestService.getRequestById(idrequest);
    this.contact = new ContactsModel()
    this.request = rq
    if(this.request != null)
    {
      let validContact = this.request.Contacts[0]
      if(validContact != null)
      {
        this.contact = this.request.Contacts[0]
      }
    }
    
    if (this.request != null && this.request.RequestStatus != null && !this.allowEdit) {
      this.email.disable();
      this.name.disable();
      this.lastname.disable();
    }
    const syncFlows = new Set([Flows.Flujo3_1,Flows.Flujo3_2,Flows.Flujo4_1,Flows.Flujo4_2,Flows.Flujo6_1,Flows.Flujo6_2])
    if(this.request != null && syncFlows.has(this.request.IdFlow)){
      this.email.disable();
      this.name.disable();
      this.lastname.disable();
    }
  }
  async clearControls() {
    this.name.setValue(null)
    this.lastname.setValue(null)
    this.email.setValue(null)
  }
  updateContact() {
    if (this.request.Contacts == null)
      this.request.Contacts = []
    let index = this.request.Contacts.findIndex(x => x.Id == this.contact.Id)
    if (index > -1) {
      this.request.Contacts[index] = this.contact
    }
    else
      this.request.Contacts.push(this.contact)

  }
  async onSubmit(): Promise<void> {
    this.hideSaveButton = true;
    this.spinner.show();
    this.contact.IdRequest = this.request.Id
    this.contact.Name = this.name.value 
    this.contact.LastName = this.lastname.value
    let res: ResponseData;

    if(this.request.IdFlow == Flows.Primeringreso || this.request.IdFlow == Flows.CambioRepresentanteAdministrador){
      let createAdminPortalRequest = new CreatePortalAdminRequest()
      createAdminPortalRequest.agentEmail = this.contact.Email
      createAdminPortalRequest.iataCode = this.request.Iata
      createAdminPortalRequest.language = this.lsService.getLSItem('language')

      let response = await this.piaFlowsValidationService.CanCreatePortalAdministrator(createAdminPortalRequest)

      if(!response.succeeded){
        let tradeResponseMessage = response.message;
        if(this.lsService.getLSItem("language") == 'es')
          tradeResponseMessage = response.message.replace('{UrlconsultasFrecuentes}',environment.consultasFrecuentesEs)
        else if(this.lsService.getLSItem("language") == 'en')
          tradeResponseMessage = response.message.replace('{UrlconsultasFrecuentes}',environment.consultasFrecuentesEn)
        else if(this.lsService.getLSItem("language") == 'pt')
          tradeResponseMessage = response.message.replace('{UrlconsultasFrecuentes}',environment.consultasFrecuentesPt)
        await this.spinner.hide();
        await Swal.fire({
          title: this.translate.instant('Request.Messages.ImportantInfo'),
          html: tradeResponseMessage,
          icon: 'warning',
          showConfirmButton: true
        });
      }
    }

    await this.requestService.postContact(this.contact).then(resp => {
      res = resp;
    })  
    
    this.spinner.hide();
    if (res.head.status.toLowerCase() == 'true') {
      await Swal.fire({
        html: this.popUp.nativeElement,
        width: 300,
        showCloseButton: true,
        showConfirmButton: false,
        
      }).then(() => {
        if(this.allowEdit)
          this.updateStatusProcess();
          this.hideSaveButton = false;      
        this.nextStep();
      })
      this.newRequestEvent.emit(this.request.Id);
    }
    else {
      await Swal.fire({
        title: 'Error!',
        text: this.translate.instant('Request.Messages.ErrorSaving'),
        icon: 'error'
      }
      )
    }
    this.hideSaveButton = false;
  }

  async updateStatusProcess(){
    this.spinner.show();
    let update =new UpdateStatusProcessModel();
    update.IdMenu=6;
    update.IdRequest=this.request.Id;
    let res: ResponseData;
    await this.requestService.postStatusCorrection(update).then(resp => {
      res = resp;
    })
    this.spinner.hide();
    if (res.head.status.toLowerCase() == 'true') {
      this.newRequestEvent.emit(this.request.Id)
    }
    else {
      await Swal.fire({
        title: 'Error!',
        text: this.translate.instant('Request.Messages.ErrorSaving'),
        icon: 'error'
      }
      )
    }
  }

  disableOption(): boolean{
    const syncFlows = new Set([Flows.Flujo3_1,Flows.Flujo3_2,Flows.Flujo4_1,Flows.Flujo4_2,Flows.Flujo6_1,Flows.Flujo6_2])
    if(this.request != null && syncFlows.has(this.request.IdFlow))
      return true
    else
      return this.form.invalid || (this.request!=null && this.request.RequestStatus!=null && !this.allowEdit)
  }

  nextStep() {
      this.nextEvent.emit();
  }

}
